// Helpers for the nested Topic -> Question workshop structure.
// Workshops always ship with both `topics[{questions:[]}]` (v1.0) and a
// derived flat `challenges[]` (BC). Anything UI‑facing should use these
// helpers so we don't hardcode either shape.

export function getTopics(workshop) {
  return workshop?.topics || [];
}

export function getFlatQuestions(workshop) {
  const topics = getTopics(workshop);
  if (topics.length > 0) {
    return topics.flatMap((t) => t.questions || []);
  }
  return workshop?.challenges || [];
}

/**
 * Locate a question inside the topic tree.
 * Returns { topic, topicIndex, totalTopics, question, questionIndex, totalQuestions,
 *           globalIndex, totalQuestionsInWorkshop } or null.
 */
export function findQuestionContext(workshop, questionId) {
  if (!workshop || !questionId) return null;
  const topics = getTopics(workshop);
  const flat = getFlatQuestions(workshop);
  let globalIndex = 0;
  for (let ti = 0; ti < topics.length; ti++) {
    const t = topics[ti];
    const qs = t.questions || [];
    for (let qi = 0; qi < qs.length; qi++) {
      globalIndex += 1;
      if (qs[qi].id === questionId) {
        return {
          topic: t,
          topicIndex: ti + 1,
          totalTopics: topics.length,
          question: qs[qi],
          questionIndex: qi + 1,
          totalQuestions: qs.length,
          globalIndex,
          totalQuestionsInWorkshop: flat.length,
        };
      }
    }
  }
  return null;
}

/** Derive a flat challenges list from topics (mirror of backend helper). */
export function flattenTopics(topics) {
  return (topics || []).flatMap((t) => t.questions || []);
}
